import SideBarGarage from '@/components/pages/subuser/SubuserContent/SideBarGarage';
import Template from '@/components/pages/subuser/SubuserContent/Template';
import React, { ReactNode } from 'react';

export default function SignTemplate({ children }: { children?: ReactNode }) {
  return (
    <Template
      side={
        <SideBarGarage
          badge="ورود امن با کد یک‌بارمصرف"
          title1="همهٔ خودروهای شما،"
          title2=" در یک گاراژ هوشمند."
          text="با یک حساب کاربری وارد شوید و خلافی خودروی خودتان و اعضای خانواده را یکجا مدیریت کنید."
        />
      }
    >
      {children}
    </Template>
  );
}
